
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPro"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPro"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calendar"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"interval_selection"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"interval_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"interval_hint"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maxDays"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maxSlots"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"minSlots"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"precedingHours"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"precedingStornoMinutes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"paymentEnabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"showPrice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"intervalDivisor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"selectedItem"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"selection"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"slots"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bookingId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"price"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"priceFloat"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currencySymbol"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isPast"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isFree"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isMe"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canDelete"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canBook"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currentSlot"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"forceProPayment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"payProfee"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":581}};
    doc.loc.source = {"body":"query getPro($id: Int!, $date: String!) {\n  getPro(input: {\n    id: $id, date: $date\n  }) {\n    calendar {\n      id,\n      name,\n      interval_selection,\n      interval_name,\n      interval_hint,\n      maxDays,\n      maxSlots,\n      minSlots,\n      precedingHours,\n      precedingStornoMinutes,\n      paymentEnabled,\n      showPrice,\n      intervalDivisor,\n      selectedItem { id, name },\n      selection { id, name }\n      slots { bookingId, date, price, priceFloat, currencySymbol, isPast, isFree, isMe, canDelete, canBook, currentSlot, forceProPayment, payProfee }\n    }\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["getPro"] = oneQuery(doc, "getPro");
        
